<template lang="pug">
  .room.anchor-room
    .divice-block-multi
      SinglePieHistogramWrap.divice-block-multi-item(:opts="SinglePieHistogramWrapOpts1" :series="SinglePieHistogramWrapData1" :class="warningFlag1")
      SinglePieHistogramWrap.divice-block-multi-item(:opts="SinglePieHistogramWrapOpts2" :series="SinglePieHistogramWrapData2" :class="warningFlag2")
      SinglePieHistogramWrap.divice-block-multi-item(:opts="SinglePieHistogramWrapOpts3" :series="SinglePieHistogramWrapData3" :class="warningFlag3")
      SinglePieHistogramWrap.divice-block-multi-item(:opts="SinglePieHistogramWrapOpts4" :series="SinglePieHistogramWrapData4" :class="warningFlag4")
      SinglePieHistogramWrap.divice-block-multi-item(:opts="SinglePieHistogramWrapOpts5" :series="SinglePieHistogramWrapData5" :class="warningFlag5")
      SinglePieHistogramWrap.divice-block-multi-item(:opts="SinglePieHistogramWrapOpts6" :series="SinglePieHistogramWrapData6" :class="warningFlag6")
    .divice-block-line
      .divice-block-line-item
        SinglePieHistogramWrap.divice-block-multi-item(:opts="SinglePieHistogramWrapOpts7" :series="SinglePieHistogramWrapData7" :class="warningFlag7")
        SinglePieHistogramWrap.divice-block-multi-item(:opts="SinglePieHistogramWrapOpts8" :series="SinglePieHistogramWrapData8" :class="warningFlag8")
      .divice-block-line-item.divice-block-line-item-col
        SwitchStatus.divice-block-thin(title="建邺侧上游锚室除湿机组运行状态" :series="SwitchStatusData1")
        RunningTimeBig.divice-block-time(title="建邺侧上游锚室除湿机组累计运行时间" :series="RunningTimeData1")
      .divice-block-line-item.divice-block-line-item-col
        SwitchStatus.divice-block-thin(title="建邺侧下游锚室除湿机组运行状态" :series="SwitchStatusData2")
        RunningTimeBig.divice-block-time(title="建邺侧下游锚室除湿机组累计运行时间" :series="RunningTimeData2")
    RefreshBlock(@refreshData="refreshData")
</template>
<script>
export default {
  name: 'anchorRoomJY',
  data () {
    return {
      timer: null,
      warningFlag1: '',
      warningFlag2: '',
      warningFlag3: '',
      warningFlag4: '',
      warningFlag5: '',
      warningFlag6: '',
      warningFlag7: '',
      warningFlag8: '',
      RunningTimeData1: null,
      SwitchStatusData1: null,
      RunningTimeData2: null,
      SwitchStatusData2: null,
      SinglePieHistogramWrapData1: null,
      SinglePieHistogramWrapOpts1: {
        title: '建邺侧上游锚室 温湿度1',
        histogramName1: 'T',
        center1: ['50%', '60%'],
        radius1: ['46%', '70%'],
        pieName1: 'RH',
        max: 50,
        pieMax: 100,
        toprichFontSize: 18,
        topFontSize: 20,
        sign: '°C'
      },
      SinglePieHistogramWrapData2: null,
      SinglePieHistogramWrapOpts2: {
        title: '建邺侧上游锚室 温湿度2',
        histogramName1: 'T',
        center1: ['50%', '60%'],
        radius1: ['46%', '70%'],
        pieName1: 'RH',
        max: 50,
        pieMax: 100,
        toprichFontSize: 18,
        topFontSize: 20,
        sign: '°C'
      },
      SinglePieHistogramWrapData3: null,
      SinglePieHistogramWrapOpts3: {
        title: '建邺侧上游锚室 温湿度3',
        histogramName1: 'T',
        center1: ['50%', '60%'],
        radius1: ['46%', '70%'],
        pieName1: 'RH',
        max: 50,
        pieMax: 100,
        toprichFontSize: 18,
        topFontSize: 20,
        sign: '°C'
      },
      SinglePieHistogramWrapData4: null,
      SinglePieHistogramWrapOpts4: {
        title: '建邺侧上游锚室 温湿度4',
        histogramName1: 'T',
        center1: ['50%', '60%'],
        radius1: ['46%', '70%'],
        pieName1: 'RH',
        max: 50,
        pieMax: 100,
        toprichFontSize: 18,
        topFontSize: 20,
        sign: '°C'
      },
      SinglePieHistogramWrapData5: null,
      SinglePieHistogramWrapOpts5: {
        title: '建邺侧下游锚室 温湿度1',
        histogramName1: 'T',
        center1: ['50%', '60%'],
        radius1: ['46%', '70%'],
        pieName1: 'RH',
        max: 50,
        pieMax: 100,
        toprichFontSize: 18,
        topFontSize: 20,
        sign: '°C'
      },
      SinglePieHistogramWrapData6: null,
      SinglePieHistogramWrapOpts6: {
        title: '建邺侧下游锚室 温湿度2',
        histogramName1: 'T',
        center1: ['50%', '60%'],
        radius1: ['46%', '70%'],
        pieName1: 'RH',
        max: 50,
        pieMax: 100,
        toprichFontSize: 18,
        topFontSize: 20,
        sign: '°C'
      },
      SinglePieHistogramWrapData7: null,
      SinglePieHistogramWrapOpts7: {
        title: '建邺侧下游锚室 温湿度3',
        histogramName1: 'T',
        center1: ['50%', '60%'],
        radius1: ['46%', '70%'],
        pieName1: 'RH',
        max: 50,
        pieMax: 100,
        toprichFontSize: 18,
        topFontSize: 20,
        sign: '°C'
      },
      SinglePieHistogramWrapData8: null,
      SinglePieHistogramWrapOpts8: {
        title: '建邺侧下游锚室 温湿度4',
        histogramName1: 'T',
        center1: ['50%', '60%'],
        radius1: ['46%', '70%'],
        pieName1: 'RH',
        max: 50,
        pieMax: 100,
        toprichFontSize: 18,
        topFontSize: 20,
        sign: '°C'
      }
    }
  },
  mounted () {
    this.getDatas()
    this.timer = setInterval(() => {
      this.getDatas()
    }, this.REFRESH_SECOND)
  },
  beforeDestroy () {
    clearInterval(this.timer)
  },
  methods: {
    refreshData () {
      this.getDatas()
      clearInterval(this.timer)
      this.timer = setInterval(() => {
        this.getDatas()
      }, this.REFRESH_SECOND)
    },
    setPieHisData (datas, dataName, data1Id, data2Id, warnName) {
      this[dataName] = {
        data1: datas[data1Id].value,
        data2: datas[data2Id].value
      }
      if (datas[data2Id].errorLevel !== 'Normal' && this[warnName] !== 'Error') {
        this[warnName] = datas[data2Id].errorLevel
      }
      if (datas[data1Id].errorLevel !== 'Normal' && this[warnName] !== 'Error') {
        this[warnName] = datas[data1Id].errorLevel
      }
    },
    getDatas () {
      this.$http.get('/deviceData/Station?stationId=d2f271f3-0119-4143-8847-496e31f4a347').then(res => {
        this.$store.commit('setLastRefreshTime')
        const __data = res.data
        this.setPieHisData(__data, 'SinglePieHistogramWrapData1', '838b9a0f-eac1-4c5a-a2f2-cc95fc7b768d', '965ee49b-3554-4b80-9a00-b53536ee2783', 'warningFlag1')
        this.setPieHisData(__data, 'SinglePieHistogramWrapData2', 'a775af62-13d5-4f5a-a0fc-168d599545cc', 'd3c397b4-86f6-416a-ba48-6546df2f144d', 'warningFlag2')
        this.setPieHisData(__data, 'SinglePieHistogramWrapData3', '8f34abdd-f143-4259-86a2-e9a4cbc19b04', 'd9833491-f072-4931-8c01-7b6be038e71e', 'warningFlag3')
        this.setPieHisData(__data, 'SinglePieHistogramWrapData4', 'e3e918c0-6f39-47a7-b54b-909d7b2c5e44', 'b96a3f6e-9a56-430e-9c4e-f23d336a55a2', 'warningFlag4')
        this.SwitchStatusData1 = {
          data: __data['529a3204-4e48-4f19-bccd-b0316a4b829d'].value,
          isError: __data['529a3204-4e48-4f19-bccd-b0316a4b829d'].errorLevel
        }
        this.RunningTimeData1 = __data['a339e0a7-44d8-4c78-8a28-8245b135024f'].value
      })
      this.$http.get('/deviceData/Station?stationId=d27038d2-fb67-4432-bc3b-b75b08297319').then(res => {
        this.$store.commit('setLastRefreshTime')
        const __data = res.data
        this.setPieHisData(__data, 'SinglePieHistogramWrapData5', '859d8200-6d59-4c81-9956-fa56cca9d962', '3805b0bf-e748-487e-a4eb-d3ef72aca7b3', 'warningFlag5')
        this.setPieHisData(__data, 'SinglePieHistogramWrapData6', 'e1ed02ef-4476-4b00-bb9a-43952c48c186', 'b41810f0-f52d-4964-bdb6-2181f0e5996f', 'warningFlag6')
        this.setPieHisData(__data, 'SinglePieHistogramWrapData7', '52c19e91-cc06-4c6f-8eaa-377f46cf3686', '391f3b8b-feab-45c7-bbaa-e8172672a415', 'warningFlag7')
        this.setPieHisData(__data, 'SinglePieHistogramWrapData8', '3e5131a0-280e-4339-bc3b-02ac80031de4', '4c2abab4-535a-45be-ba9c-f374afe4ddb0', 'warningFlag8')
        this.SwitchStatusData2 = {
          data: __data['972c1a04-fe60-48f4-8e1d-a0b94ecaba83'].value,
          isError: __data['972c1a04-fe60-48f4-8e1d-a0b94ecaba83'].errorLevel
        }
        this.RunningTimeData2 = __data['a56c1390-3632-48a3-845e-69cdec9b2af3'].value
      })
    }
  }
}
</script>
<style lang="scss" scoped>
.anchor-room {
  display: flex;
  justify-content: space-between;
  flex-wrap: wrap;
  align-items: stretch;
  align-content: stretch;
  padding-top: 10px;
  .divice-block-multi {
    width: 100%;
    height: calc(50% - 15px);
    background-color: transparent;
    &-item {
      width: calc((100% / 6) - 10px);
      background-color: rgba(255, 255, 255, 0.6);
    }
  }
  .divice-block-line {
    width: 100%;
    height: calc(50% - 10px);
    background-color: transparent;
    display: flex;
    justify-content: space-between;
    align-items: stretch;
    &-item {
      width: calc(100% / 3 - 10px);
      display: flex;
      box-sizing: border-box;
      justify-content: space-between;
      align-items: stretch;
      .divice-block-multi-item {
        width: calc(50% - 15px);
        &:first-child {
          margin-right: 10px;
        }
      }
    }
    .divice-block-line-item-col {
      display: flex;
      flex-direction: column;
      justify-content: space-between;
    }
  }
  .divice-block-thin {
    height: 42px;
    width: 100%;
    box-sizing: border-box;
  }
  .divice-block-time {
    height: calc(100% - 60px);
    width: 100%;
    box-sizing: border-box;
  }
  .divice-block-multi {
    display: flex;
    justify-content: space-between;
    align-items: stretch;
  }
}
</style>
